// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    env: 'test',
    membershipBackendHost: 'tanocom.it',
    libraryBackendHost: 'tanocom.it',
    publishingBackendHost: 'tanocom.it',
    membershipBackendAddress: 'https://services-test-winomembership.tanocom.it/winoMembership',
    libraryBackendAddress: 'https://services-test-winolibrary.tanocom.it/winoLibrary',
    publishingBackendAddress: 'https://services-test-winopublishing.tanocom.it/winoPublishing',
    membershipModuleName: 'wino.frontend.membership',
    libraryModuleName: 'wino.frontend.library',
    publishingModuleName: 'wino.frontend.publishing',
    winoMembershipClient_uuid: '3f07ecbf-7e2a-443e-b364-b735b4a79540',
    winoLibraryClient_uuid: 'c90b67dc-d554-11ed-afa1-0242ac120002',
    winoPublishingClient_uuid: '859c338c-d554-11ed-afa1-0242ac120002',
    permissionPolicy: 'enabled',
    oauth2baseUri: '/oauth2/authorize',
    oauth2Google: '/google?landing_uri=',
    oauth2Facebook: '/facebook?landing_uri=',
    oauth2LandingUri: 'https://test-winowino.tanocom.it/winoMembership/oauth2/redirect',
    oauth2AccessToken: 'accessToken',
    authenticationAuthTokenCookieName: 'winoAuthToken',
    authenticationRefreshTokenCookieName: 'winoRefreshToken',
    authenticationTypeCookieName: 'userAuthentication',
    authenticationTypeCookieValue_local: 'local',
    authenticationTypeCookieValue_session: 'session'
};